import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const CheckCircleSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default CheckCircleSVG;
